import { render, staticRenderFns } from "./SkinSetSteamIdDialog.vue?vue&type=template&id=5b51ba8a&scoped=true&"
import script from "./SkinSetSteamIdDialog.vue?vue&type=script&lang=ts&"
export * from "./SkinSetSteamIdDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b51ba8a",
  null
  
)

export default component.exports